import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { DfApiConfigService } from '@df/api/config/df-api-config.service';
import { App } from '@df/core/app';
import { IAddressData } from '@df/session/api/address-book/address';
import { Nexus } from '@tomandco/nexus-api-types';
import find from 'lodash-es/find';
@Component({
    selector: 'account-address-body',
    templateUrl: './account-address-body.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class AccountAddressBodyComponent {
    @Input()
    addressData?: IAddressData;

    apiConfigService = inject(DfApiConfigService);

    private app = inject(App);
    get lines() {
        if (!this.addressData) {
            return [];
        }
        const lines = [['street_1'], ['street_2'], ['city'], ['postcode']]
            .map(fields => fields.map(field => this.addressData?.[field]).filter(i => !!i))
            .filter(i => i.length);
        const countryId = this.addressData?.country_id;
        if (countryId) {
            const country = this.getCountryFromAddress(countryId);
            if (country?.name) {
                lines.push([country.name]);
            }
        }
        return lines;
    }
    get telephone(): string | undefined {
        return this.addressData?.telephone;
    }

    private getCountryFromAddress(countryId: string): Nexus.Lib.General.Country | undefined {
        return countryId ? find(this.apiConfigService?.countries, country => country.code === countryId) : undefined;
    }
}
